module.exports = __webpack_public_path__ + "media/img/private-venue/2-e0f52d08790586c99640b7461de33b97.png";